export default "mutation createNewUser($attributes: NewUserAttributes) {\n  createNewUser(attributes: $attributes) {\n    email\n    errors\n  }\n}\n"